import api_login from '@/api/login.js'
import { setCookie } from '@/utils/index.js'
import { remoteLoad } from '@/utils/remoteLoad.js'
const getToken = () => {
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-undef
    croods.customPlugin({
      action: 'UserPlugin.login', 
      params: {},
      success: (res) => {
        if (res?.token) {
          api_login.loginByWstToken({token: res?.token}).then((res) => {
            setCookie('token', res.data.token)
            res.data.refreshToken && setCookie('refreshToken', res.data.refreshToken)
            resolve()
          })
        }
      },
      fail: (msg) => {
        reject(msg)
      }
    })
  })
}
const reGetUserInfo = () => {
  getToken()
}
const wstLogin = {
  login() {
    return new Promise((resolve, reject) => {
      remoteLoad(location.pathname + 'static/js/croods-1.3.3.js').then(res => {
        window.reGetUserInfo = reGetUserInfo
        getToken().then(() => {
          resolve()
        }, msg => {
          reject(msg)
        })
      })
    })
    
  }
}

export default wstLogin
